import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a4939d4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/assets/pages/about/styles/index.response.css?vue&type=style&index=0&id=5a4939d4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4939d4",
  null
  
)

export default component.exports